
export default {
  add: 'Add',
  confirm: 'Confirm',
  search: 'Search',
  operate: 'Operate',
  detail: 'Detail',
  edit: 'Edit',
  delete: 'Delete',
  save: 'Save',
  cancel: 'Cancel',
  deleteMsg: 'Delete successfully!',
  deleteboxContent: 'This operation will permanently delete the item, do you want to continue?',
  tip: 'Tip',
  error: 'Error',
  saveSuccess: 'Save successfully',
  serialNumber: 'No.',
  confirmBlock: "Confirm",
  cancelBlock: "Cancel",
  searchBlock: "Search",
  confirmBlock1: "Confirm",
  to: "To",
  submit: "Submit",
  upload: "Upload",
  success: "Success",
  publish: "Publish",
  yse: "Yes",
  no: "No",
  pleaseSelect: "Please select",
  to: "To",
  startDate: "Start date",
  endDate: "End date",
  searchCondition: "Search condition",
  failure: "Failure",
  count: 'Count',
  piece: 'Piece',
  currentDate: 'Current Date',
  currentWeek: 'Current Week',
  currentMonth: 'Current Month',
  currentYear: 'Current Year',
  goback: 'Go Back',
  network: 'Request failed,',
  clickRefresh: 'Click refresh',
  noData: 'No Data',
  loading: 'Loading...',
  refresh: 'Refresh',
};


// WEBPACK FOOTER //
// ./src/locale/lang/en/common.js